module.exports = "/_next/static/images/icon-android-26a8d83a.png";